import axios from 'axios';
import { loadLanguageAsync } from '@/i18n';

const translations = {
  namespaced: true,

  state: {
    currentLanguage: 'en',
    availableLanguages: [],
    translationsCache: {},
    loading: false
  },

  getters: {
    currentLanguage: state => state.currentLanguage,
    availableLanguages: state => state.availableLanguages,
    isLanguageLoaded: state => (code) => {
      return !!state.translationsCache[code];
    },
    loading: state => state.loading
  },

  mutations: {
    SET_CURRENT_LANGUAGE(state, code) {
      state.currentLanguage = code;
    },
    SET_AVAILABLE_LANGUAGES(state, languages) {
      state.availableLanguages = languages;
    },
    CACHE_TRANSLATIONS(state, { code, translations }) {
      state.translationsCache[code] = translations;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    }
  },

  actions: {
    async fetchAvailableLanguages({ commit }) {
      try {
        console.log('🌍 Fetching available languages from API...');
        const response = await axios.get('/api/translations/languages', {
          withCredentials: true
        });
        console.log('📥 API response:', response.data);
        // API already filters by isActive, so no need to filter again
        const languages = response.data;
        console.log('✓ Languages to commit:', languages);
        commit('SET_AVAILABLE_LANGUAGES', languages);
        console.log('✓ Committed to store');
        return languages;
      } catch (error) {
        console.error('❌ Error fetching languages:', error);
        console.error('Error details:', error.response?.data || error.message);
        throw error;
      }
    },

    async setLanguage({ commit, rootState }, languageCode) {
      try {
        console.log(`🌐 Changing language to: ${languageCode}`);
        commit('SET_LOADING', true);

        // Load translations via i18n
        console.log('📥 Loading translations...');
        await loadLanguageAsync(languageCode);
        console.log('✓ Translations loaded');

        // Update state
        commit('SET_CURRENT_LANGUAGE', languageCode);
        console.log('✓ Store updated with new language');

        // Persist to localStorage
        localStorage.setItem('preferredLanguage', languageCode);
        console.log('✓ Language saved to localStorage');

        // If user is logged in, save to account
        if (rootState.auth?.user) {
          await axios.put('/api/users/language', {
            languageCode
          }, {
            withCredentials: true
          });
          console.log('✓ Language saved to user account');
        }

        commit('SET_LOADING', false);
        console.log(`✅ Language change complete: ${languageCode}`);
        return languageCode;
      } catch (error) {
        console.error('❌ Error setting language:', error);
        commit('SET_LOADING', false);
        throw error;
      }
    },

    async initializeLanguage({ commit, dispatch, rootState }) {
      // Check if user has preference
      let preferredLanguage = 'en';

      if (rootState.auth?.user?.preferredLanguage) {
        preferredLanguage = rootState.auth.user.preferredLanguage;
      } else if (localStorage.getItem('preferredLanguage')) {
        preferredLanguage = localStorage.getItem('preferredLanguage');
      }

      await dispatch('setLanguage', preferredLanguage);
    }
  }
};

export default translations;
